export default __webpack_public_path__ + "static/media/ucy.d1416a56.svg";